import React, { useState, useContext } from 'react';
import ColorsMain from '../../colors/ColorsMain';
import { UtilContext } from "../../context/UtilContext";
import { GLOBAL_LANGUAGE } from "../../language/language";

const Navbar = ({ onClose }) => {
  const [hovered, setHovered] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const { language } = useContext(UtilContext); // Usa el contexto de Auth

  const handleOpenPopup = () => {
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const handleConfirmLogout = () => {
    setShowPopup(false);
    onClose();
  };

  return (
    <div className={`w-full flex justify-end items-center bg-[${ColorsMain.bgMain}]`}>
      <button
        onClick={handleOpenPopup}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className={`flex items-center justify-center gap-2 text-white rounded-lg transition-all duration-200 
          ${hovered ? `px-4 py-2.5 bg-[#2f2f36]` : `w-10 h-10 bg-[#26262D]`}`}
        aria-label="Cerrar"
      >
        {hovered && <span className="text-white text-sm"> {GLOBAL_LANGUAGE[language].navbar.label_hover} </span>}
        <span className="text-lg">✕</span>
      </button>

      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-[#26262D] p-8 rounded-[12px] w-[490px]">
            <p className="font-semibold mb-4 text-3xl">{GLOBAL_LANGUAGE[language].navbar.title}</p>
            <p className={`text-sm text-[${ColorsMain.bgLogin}] mb-6 text-[16px]`}>
              {GLOBAL_LANGUAGE[language].navbar.description}
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={handleClosePopup}
                className="px-4 py-2 text-white rounded-lg"
                style={{ backgroundColor: ColorsMain.borderGray }}
              >
                {GLOBAL_LANGUAGE[language].navbar.label_button_back}
              </button>
              <button
                onClick={handleConfirmLogout}
                className="px-4 py-2 rounded-lg"
                style={{
                  backgroundColor: ColorsMain.bgButtonWhite,
                  color: ColorsMain.textBlackButton,
                }}
              >
                {GLOBAL_LANGUAGE[language].navbar.label_button_next}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
